<form [formGroup]="SlideTypeLines">
    <!-- Header -->
    <div class="card mb-3">
        <div class="card-body row">
            <div class="col-md-2">
                <label>Shortcode</label>
                <input class="form-control" formControlName="slideTypeShortcode">
            </div>
            <div class="col-md-5">
                <label>Slide Type Name</label>
                <input class="form-control" formControlName="slideTypeName">
            </div>
            <div class="col-md-5">
                <label>Remarks</label>
                <input class="form-control" formControlName="slidetypeRemarks">
            </div>
            <div class="col-md-5">
                <label>Layout</label>
                <input class="form-control" formControlName="slideLayoutShortcode">
            </div>
            <div class="col-md-7">
                <label>Reading material (slide)</label>
                <input class="form-control" formControlName="ReadingMaterial" placeholder="include=Y|page=NEW|section=N">
                <small class="text-muted">include=N omits the whole slide (section-break types). page=NEW or SAME. section=Y adds a Word section.</small>
            </div>
        </div>
    </div>

    <!-- Group Visibility Toggles -->
    <div class="mb-2">
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group1 = !groupVisibility.group1"
            type="button">
            Content and Source
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group2 = !groupVisibility.group2"
            type="button">
            Shape Details
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group3 = !groupVisibility.group3"
            type="button">
            Text details
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group4 = !groupVisibility.group4"
            type="button">
            group properties
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group5 = !groupVisibility.group5"
            type="button">
            Size and location
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group6 = !groupVisibility.group6"
            type="button">
            Animation
        </button>
        <button class="btn btn-sm btn-outline-primary me-2" (click)="groupVisibility.group7 = !groupVisibility.group7"
            type="button">
            Auto
        </button>
    </div>

    <!-- Detail Rows -->
    <div formArrayName="details">
        <div *ngFor="let row of details.controls; let i = index" [formGroupName]="i" class="card mb-3 border-primary">
            <div class="card-body">
                <div class="row align-items-center mb-2">
                    <div class="col-md-1"><strong>{{ i + 1 }}</strong></div>
                    <div class="col-md-4">
                        <select class="form-control" formControlName="STType">
                            <option value="">Select Type</option>
                            <option *ngFor="let type of stTypes" [value]="type.ValidVal">{{ type.ValidVal }}</option>
                        </select>
                    </div>
                     <div class="col-md-4">
                                <label>{{ isObjGrpRow($any(row)) ? 'Object group' : 'Line Name' }}</label>
                                <select *ngIf="isObjGrpRow($any(row))" class="form-control" formControlName="STName">
                                    <option value="">Select object group</option>
                                    <option *ngFor="let og of objectGroupSelectOptions(row.get('STName')?.value)"
                                        [value]="og.objGroupShortcode">
                                        {{ og.objGroupShortcode }}{{ og.objGroupName ? ' — ' + og.objGroupName : '' }}
                                    </option>
                                </select>
                                <input *ngIf="!isObjGrpRow($any(row))" class="form-control" formControlName="STName">
                            </div>
                    <div class="col-md-4">
                        <button class="btn btn-sm btn-secondary" (click)="moveUp(i)" type="button">▲</button>
                        <button class="btn btn-sm btn-secondary" (click)="moveDown(i)" type="button">▼</button>
                        <button class="btn btn-sm btn-danger" (click)="deleteRow(i)" type="button">🗑</button>
                    </div>
                </div>
                <div class="d-flex flex-row flex-wrap gap-3">
                    <!-- Group 1 Card -->
                    <!--div *ngIf="groupVisibility.group1" formGroupName="group1" class="card p-2 flex-fill"-->
                    <div *ngIf="groupVisibility.group1"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Content & Source</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Value / filename</label>

                                <input class="form-control" formControlName="STVal">
                            </div>
                            
                            <div class="col-md-16">
                                <label>Source Type</label>
                                <select class="form-control" formControlName="STSourceType">
                                    <option value="">Select Source Type</option>
                                    <option *ngFor="let sourcetype of sourceTypes" [value]="sourcetype.ValidVal">{{
                                        sourcetype.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16 mt-2">
                                <label>Allow translate</label>
                                <select class="form-control" formControlName="STAllowTranslate">
                                    <option value="Y">Y — translate with AI</option>
                                    <option value="N">N — keep English as-is (e.g. page no)</option>
                                </select>
                            </div>
                            <div class="col-md-16 mt-2">
                                <label>Text break (seed soft-break)</label>
                                <input class="form-control" type="number" formControlName="STTextBreak" min="0" step="1"
                                    placeholder="blank/0=off; 1=auto from width; &gt;1=max chars" />
                                <small class="text-muted">Newlines always split at seed. Soft-break by length only when set.</small>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="groupVisibility.group7" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Automation</div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-3">
                                    <label>Auto source</label>
                                    <select class="form-control" formControlName="STAutoSource">
                                        <option value="">—</option>
                                        <option *ngFor="let s of lineAutoSources" [value]="s">{{ s }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto value</label>
                                    <input class="form-control" formControlName="STAutoVal" maxlength="45" />
                                </div>
                                <div class="col-md-3">
                                    <label>Auto condition</label>
                                    <select class="form-control" formControlName="STAutoCondition">
                                        <option value="">—</option>
                                        <option *ngFor="let c of lineAutoConditions" [value]="c">{{ c }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Loop group</label>
                                    <input class="form-control" type="number" formControlName="STAutoloopGroup" min="0" step="1" />
                                </div>
                                <div class="col-md-3">
                                    <label>Auto entry before → PSL show with</label>
                                    <select class="form-control" formControlName="STAutoEntryBefore">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('STAutoEntryBefore')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto entry after → PSL show after</label>
                                    <select class="form-control" formControlName="STAutoEntryAfter">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('STAutoEntryAfter')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto exit before → PSL exit with</label>
                                    <select class="form-control" formControlName="STAutoExitBefore">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('STAutoExitBefore')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <label>Auto exit after → PSL exit after</label>
                                    <select class="form-control" formControlName="STAutoExitAfter">
                                        <option *ngFor="let opt of timelineMarkerSelectOptions(row.get('STAutoExitAfter')?.value)" [value]="opt.value">{{ opt.label }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Group 2 Card -->
                    <div *ngIf="groupVisibility.group2"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Shape</div>
                        <div class="card-body">

                            <div class="col-md-16">
                                <label>Shape Type</label>
                                <select class="form-control" formControlName="STShapeType">
                                    <option value="">Select Shape Type</option>
                                    <option *ngFor="let shapeType of shapeTypes" [value]="shapeType.ValidVal">{{
                                        shapeType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Shape Border</label>
                                <select class="form-control" formControlName="STShapeBorder">
                                    <option value="">Select border Type</option>
                                    <option *ngFor="let shapeBorderType of shapeBorderTypes" [value]="shapeBorderType.ValidVal">{{
                                        shapeBorderType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Shape Fill</label>
                                <input class="form-control" formControlName="STShapeFill">
                            </div>
                            <div class="col-md-16">
                                <label>Shape Shadow</label>
                                <select class="form-control" formControlName="STShapeShadow">
                                     <option value="">Select shadow Type</option>
                                    <option *ngFor="let shapeShadowType of shapeShadowTypes" [value]="shapeShadowType.ValidVal">{{
                                        shapeShadowType.ValidVal }}</option>
                                </select>
                            </div>

                        </div>
                    </div>


                    <!-- Group 3 Card -->
                    <div *ngIf="groupVisibility.group3"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Text</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Text Align</label>
                                <select class="form-control" formControlName="STtextAlign">
                                    <option value="">Select </option>
                                    <option *ngFor="let textalignType of textalignTypes"
                                        [value]="textalignType.ValidVal">{{
                                        textalignType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Text font size</label>
                                <input class="form-control" formControlName="STTextFont" placeholder="Template label, e.g. FontSize2">
                            </div>
                            <div class="col-md-16">
                                <label>Text Color</label>
                                <input class="form-control" formControlName="STTextColor">
                            </div>
                            <div class="col-md-16">
                                <label>Is bulleted?</label>
                                <select class="form-control" formControlName="STBulletFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Bullet size</label>
                                <input class="form-control" formControlName="STBulletSize">
                            </div>
                            <div class="col-md-16">
                                <label>Bullet Character</label>
                                <input class="form-control" formControlName="STBulletCharacter">
                            </div>
                            <div class="col-md-16">
                                <label>Text style for Numbers</label>
                                <input class="form-control" formControlName="STNumTextStyle">
                            </div>
                            <div class="col-md-16">
                                <label>Reading material</label>
                                <select class="form-control" formControlName="ReadingMaterial">
                                    <option value="">— skip —</option>
                                    <option *ngFor="let rmType of readingMaterialSelectOptions(row.get('ReadingMaterial')?.value)" [value]="rmType.ValidVal">{{ rmType.ValidVal }}</option>
                                </select>
                                    <small class="text-muted">Style from template ReadingMaterial rows, Image to include a picture, or N to skip.</small>
                            </div>
                        </div>
                    </div>

                    <!-- Group 4 Card -->
                    <div *ngIf="groupVisibility.group4"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Group</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Use group color?</label>
                                <select class="form-control" formControlName="STGroupColorFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Group flip?</label>
                                <select class="form-control" formControlName="STGroupTraverseFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Reverse row order?</label>
                                <select class="form-control" formControlName="STRowReverseFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Group object overlap?</label>
                                <select class="form-control" formControlName="STOverlapFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Group fixed size?</label>
                                <select class="form-control" formControlName="STFixedSizeFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Maximum no of rows</label>
                                <input class="form-control" formControlName="STMaxRows">
                            </div>
                            <div class="col-md-16">
                                <label>Maximum no of columns</label>
                                <input class="form-control" formControlName="STMaxCols">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="groupVisibility.group5"  class="card p-2 flex-fill">
                        <div class="card-header bg-light">Size and Location</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>X position(cms)</label>
                                <input class="form-control" formControlName="STXpos">
                            </div>
                            <div class="col-md-16">
                                <label>Y position(cms)</label>
                                <input class="form-control" formControlName="STYpos">
                            </div>
                            <div class="col-md-16">
                                <label>Width (cms)</label>
                                <input class="form-control" formControlName="STWidth">
                            </div>
                            <div class="col-md-16">
                                <label>Height(cms)</label>
                                <input class="form-control" formControlName="STHeight">
                            </div>
                        </div>
                    </div>

                    <!-- Group 6 Card -->
                    <div *ngIf="groupVisibility.group6" class="card p-2 flex-fill">
                        <div class="card-header bg-light">Animation</div>
                        <div class="card-body">
                            <div class="col-md-16">
                                <label>Entry animation type</label>
                                <select class="form-control" formControlName="STEntryAnimType">
                                    <option value="">Select </option>
                                    <option *ngFor="let entryanimType of entryanimTypes"
                                        [value]="entryanimType.ValidVal">{{
                                        entryanimType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Exit animation type</label>
                                <select class="form-control" formControlName="STExitAnimType">
                                    <option value="">Select </option>
                                    <option *ngFor="let exitanimType of exitanimTypes" [value]="exitanimType.ValidVal">
                                        {{
                                        exitanimType.ValidVal }}</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Animation time</label>
                                <input class="form-control" formControlName="STExitAnimTime">
                            </div>
                            <div class="col-md-16">
                                <label>Is previous button?</label>
                                <select class="form-control" formControlName="STPreviousFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Is next button?</label>
                                <select class="form-control" formControlName="STNextFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                            <div class="col-md-16">
                                <label>Is replay button?</label>
                                <select class="form-control" formControlName="STReplayFlag">
                                    <option value="">Select</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="mb-3">
        <button type="button" class="btn btn-outline-primary" (click)="addRow()">➕ Add Row</button>
    </div>

    <div class="text-end">
        <button type="button" class="btn btn-success" (click)="saveST()">💾 Save</button>
    </div>

</form>